// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"6f552539","184":"fc45929b","293":"fc45929b","473":"fc45929b","506":"fc45929b","515":"6f552539","531":"fc45929b","821":"93d14f95","910":"fc45929b","948":"be96bba1","962":"fc45929b"}[chunkId] + ".chunk.css";
};